import { DefaultService } from '@/services/DefaultService';

export default class CampanhaService extends DefaultService {

	constructor(http, router, env) {
		super(http, router, env);
	}

	updateSituacao(campanha) {
    return this._http.post(`${this._env}/vendas/campanha/updatesituacao`, campanha, this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw err;
    });
  }

	findAll(column, order, page, limit, situacao, ...params) {
		return this._http.get( encodeURI(`${this._env}/vendas/campanha.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&param=${params}`), this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw new Error('Problems while jobs are loading');
		});
	}

	findAllCombo(...params) {
		return this._http.get(encodeURI(`${this._env}/vendas/getcombo/campanha.json?param=${params}`), this._headers).then(res => {
      return res.body;
		}, err => {
      this.verifyError(err);
      throw new Error('Problems while jobs are loading');
		});
	}

    findAllNaoVinculadoUsuario(idusuario, page = 0, limit = 50, order = 'asc', column = 'descricao', ...param) {
		return this._http.get(encodeURI(`${this._env}/vendas/findAllVinculoUsuario/campanha/${idusuario}.json?page=${page}&limit=${limit}&order=${order}&column=${column}&param=${param}`), this._headers).then(res => {
      return res.body;
		}, err => {
      this.verifyError(err);
      throw new Error('Problems while jobs are loading');
		});
	}
    
	find(id) {
		return this._http.get(`${this._env}/vendas/campanha/${id}.json`, this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw new Error('Problems while jobs are loading');
    });
	}

	save(form) {
        return this._http.post(`${this._env}/vendas/campanha`, form, this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw err;
    });
  }
}